"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBannerContext = exports.BannerProvider = exports.BannerContext = void 0;
var react_1 = __importStar(require("react"));
exports.BannerContext = (0, react_1.createContext)(undefined);
var counter = 0;
// FEEDBACK:
// needs to be outside the BannerProvider, else it gets called twice.
// which wouldn't be a problem if this function was pure, but its not cuz of the counter. 
// need to find an alt implementation to that.
// discussion on useReducer being pure: https://github.com/facebook/react/issues/16295
var bannerReducer = function (state, action) {
    var newInfoState, newAlertState, newEntry, alreadyExistsIdx;
    switch (action.type) {
        case "ADD_ALERT":
            var alertState = state.alertState;
            counter = counter + 1;
            newEntry = __assign({ id: "ALERT-".concat(counter) }, action.payload
            // if an id is passed in the payload itelf, it will override the counter based id 
            );
            // if a alert banner exists with the same id, as the new one coming in,
            // we remove that first.
            newAlertState = alertState.filter(function (d) { return d.id !== newEntry.id; });
            alreadyExistsIdx = alertState.findIndex(function (d) { return d.id === newEntry.id; });
            if (alreadyExistsIdx !== -1) {
                alertState[alreadyExistsIdx] = newEntry;
                newAlertState = alertState;
            }
            else {
                newAlertState = __spreadArray([newEntry], alertState, true);
            }
            return __assign(__assign({}, state), { alertState: newAlertState });
        case "ADD_INFO":
            var infoState = state.infoState;
            counter = counter + 1;
            newEntry = __assign({ id: "INFO-".concat(counter) }, action.payload
            // if an id is passed in the payload itelf, it will override the counter based id
            );
            // if a info banner exists with the same id, as the new one coming in,
            // we remove that first.
            alreadyExistsIdx = infoState.findIndex(function (d) { return d.id === newEntry.id; });
            if (alreadyExistsIdx !== -1) {
                infoState[alreadyExistsIdx] = newEntry;
                newInfoState = infoState;
            }
            else {
                newInfoState = __spreadArray([newEntry], infoState, true);
            }
            return __assign(__assign({}, state), { infoState: newInfoState });
        case "REMOVE_ALERT":
            newAlertState = state.alertState.filter(function (a) { return a.id !== action.id; });
            return __assign(__assign({}, state), { alertState: newAlertState });
        case "REMOVE_INFO":
            newInfoState = state.infoState.filter(function (a) { return a.id !== action.id; });
            return __assign(__assign({}, state), { infoState: newInfoState });
        case "REMOVE_ALL_INFO":
            return __assign(__assign({}, state), { infoState: [] });
        case "REMOVE_ALL_ALERT":
            return __assign(__assign({}, state), { alertState: [] });
        default:
            return state;
    }
};
/**
 * @component Renders a context provider component for the banner component.
 *
 * - The context value object containing the following properties:
 * @property {BannerState} BANNER_STATE: The state of the banner.
 * @property {(options_msg: string | Omit<BannerEntry, "id">, color?: string, timeOut?: number) => string} SET_INFO_BANNER: A callback function to be called when adding an info banner. The function takes the text to be displayed in the banner, the color of the banner, and the time in milliseconds to wait before removing the banner as arguments.
 * @property {(options_msg: string | Omit<BannerEntry, "id">, color?: string, timeOut?: number) => string} SET_ALERT_BANNER: A callback function to be called when adding an alert banner. The function takes the text to be displayed in the banner, the color of the banner, and the time in milliseconds to wait before removing the banner as arguments.
 * @property {(e: React.MouseEvent | null, id: string) => void} REMOVE_ALERT_BANNER: A callback function to be called when removing an alert banner. The function takes the mouse event and the id of the banner as arguments.
 * @property {(e: React.MouseEvent | null, id: string) => void} REMOVE_INFO_BANNER: A callback function to be called when removing an info banner. The function takes the mouse event and the id of the banner as arguments.
 * @property {(e: React.MouseEvent) => void} REMOVE_ALL_INFO_BANNERS: A callback function to be called when removing all info banners. The function takes the mouse event as an argument.
 * @property {(e: React.MouseEvent) => void} REMOVE_ALL_ALERT_BANNERS: A callback function to be called when removing all alert banners. The function takes the mouse event as an argument.
 * @return {ReactElement} The rendered context provider component.
 */
var BannerProvider = function (_a) {
    var children = _a.children;
    var initialState = { alertState: [], infoState: [] };
    var _b = (0, react_1.useReducer)(bannerReducer, initialState), BANNER_STATE = _b[0], BANNER_DISPATCH = _b[1];
    var REMOVE_ALERT_BANNER = function (e, id) {
        BANNER_DISPATCH({ type: "REMOVE_ALERT", id: id });
    };
    var REMOVE_INFO_BANNER = function (e, id) {
        BANNER_DISPATCH({ type: "REMOVE_INFO", id: id });
    };
    var REMOVE_ALL_INFO_BANNERS = function (e) {
        BANNER_DISPATCH({ type: "REMOVE_ALL_INFO" });
    };
    var REMOVE_ALL_ALERT_BANNERS = function (e) {
        BANNER_DISPATCH({ type: "REMOVE_ALL_ALERT" });
    };
    // the config of bannner can either be passed as a object, or plain arguments.
    var SET_INFO_BANNER = function (options_msg, color, timeOut) {
        var options;
        if (typeof options_msg === 'string') { //means it is the 'msg' config
            options = {
                msg: options_msg,
                color: color || 'green', //defaults to green
                timeOut: timeOut
            };
        }
        else {
            options = options_msg;
        }
        BANNER_DISPATCH({ type: "ADD_INFO", payload: options });
        return "INFO-".concat(counter); //bannerId
    };
    var SET_ALERT_BANNER = function (options_msg, color, timeOut) {
        var options;
        if (typeof options_msg === 'string') { //means it is the 'msg' config
            options = {
                msg: options_msg,
                color: color || 'green', //defaults to green
                timeOut: timeOut
            };
        }
        else {
            options = options_msg;
        }
        BANNER_DISPATCH({ type: "ADD_ALERT", payload: options });
        return "ALERT-".concat(counter); //bannerId
    };
    var contextValue = {
        BANNER_STATE: BANNER_STATE,
        SET_INFO_BANNER: SET_INFO_BANNER,
        SET_ALERT_BANNER: SET_ALERT_BANNER,
        REMOVE_ALERT_BANNER: REMOVE_ALERT_BANNER,
        REMOVE_INFO_BANNER: REMOVE_INFO_BANNER,
        REMOVE_ALL_INFO_BANNERS: REMOVE_ALL_INFO_BANNERS,
        REMOVE_ALL_ALERT_BANNERS: REMOVE_ALL_ALERT_BANNERS
    };
    return react_1.default.createElement(exports.BannerContext.Provider, { value: contextValue }, children);
};
exports.BannerProvider = BannerProvider;
/**
 * @hook useBannerContext
 *
 * - The props object containing the following properties:
 * @property {BannerState} BANNER_STATE: The state of the banner.
 * @property {(options_msg: string | Omit<BannerEntry, "id">, color?: string, timeOut?: number) => string} SET_INFO_BANNER: A callback function to be called when adding an info banner. The function takes the text to be displayed in the banner, the color of the banner, and the time in milliseconds to wait before removing the banner as arguments.
 * @property {(options_msg: string | Omit<BannerEntry, "id">, color?: string, timeOut?: number) => string} SET_ALERT_BANNER: A callback function to be called when adding an alert banner. The function takes the text to be displayed in the banner, the color of the banner, and the time in milliseconds to wait before removing the banner as arguments.
 * @property {(e: React.MouseEvent | null, id: string) => void} REMOVE_ALERT_BANNER: A callback function to be called when removing an alert banner. The function takes the mouse event and the id of the banner as arguments.
 * @property {(e: React.MouseEvent | null, id: string) => void} REMOVE_INFO_BANNER: A callback function to be called when removing an info banner. The function takes the mouse event and the id of the banner as arguments.
 * @property {(e: React.MouseEvent) => void} REMOVE_ALL_INFO_BANNERS: A callback function to be called when removing all info banners. The function takes the mouse event as an argument.
 * @property {(e: React.MouseEvent) => void} REMOVE_ALL_ALERT_BANNERS: A callback function to be called when removing all alert banners. The function takes the mouse event as an argument.
 * @return {BannerContextType} The context value.
 */
var useBannerContext = function () {
    var context = (0, react_1.useContext)(exports.BannerContext);
    if (context === undefined) {
        throw new Error('useBannerContext must be used within a BannerProvider');
    }
    return context;
};
exports.useBannerContext = useBannerContext;
